const EmojiIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.82001 0C2.18001 0 0.0100098 2.17 0.0100098 5.81V14.18C0.0100098 17.83 2.18001 20 5.82001 20H14.19C17.83 20 20 17.83 20 14.19V5.81C20.01 2.17 17.84 0 14.2 0H5.82001ZM5.54001 5.72C6.25001 6.43 7.41001 6.43 8.12001 5.72C8.41001 5.43 8.89001 5.43 9.18001 5.72C9.47001 6.01 9.47001 6.49 9.18001 6.78C8.53001 7.43 7.68001 7.75 6.83001 7.75C5.98001 7.75 5.13001 7.43 4.48001 6.78C4.19001 6.48 4.19001 6.01 4.48001 5.72C4.77001 5.43 5.25001 5.43 5.54001 5.72ZM5.13001 11.9C5.13001 11.2 5.70001 10.62 6.40001 10.62H13.6C14.3 10.62 14.87 11.19 14.87 11.9C14.89 14.59 12.7 16.78 10.01 16.78C7.32001 16.78 5.13001 14.59 5.13001 11.9ZM13.19 7.75C12.34 7.75 11.49 7.43 10.84 6.78C10.55 6.49 10.55 6.01 10.84 5.72C11.13 5.43 11.61 5.43 11.9 5.72C12.61 6.43 13.77 6.43 14.48 5.72C14.77 5.43 15.25 5.43 15.54 5.72C15.83 6.01 15.83 6.48 15.54 6.78C14.89 7.43 14.04 7.75 13.19 7.75Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default EmojiIcon;
